import React, { useState, useEffect } from 'react';
import { Typography, Form, Input, Upload, Button, InputNumber, Row, Col, Tooltip, message, Spin } from 'antd';
import { createUseStyles } from 'react-jss'

import { CopyToClipboard } from 'react-copy-to-clipboard';

import { UploadOutlined } from '@ant-design/icons';
import Icofont from 'react-icofont';
import { errorCatch, GET } from 'fennec-ui';

const { Title } = Typography;

const useStyles = createUseStyles({
    transfer: {
        '&.ant-transfer': {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        },
        '&.ant-transfer .ant-transfer-list ': {
            flex: "auto",
            height: "500px",
        }
    }
})

export default function PromResultSeriiVK(props) {
    const { auth, object } = props;

    const [loading, setLoading] = useState(false);
    const [text, setText] = useState("");
    const [maxPlace, setMaxPlace] = useState(3);

    const onClickButton = (e) => {
        setLoading(true)
        GET(auth, `/api/rezultati-serii/prom-result-vk/${object.ID}/${maxPlace}`, ({ data }) => {
            setText(data);
            setLoading(false)
        }, (r, type) => errorCatch(r, type, () => setLoading(false)));
    }

    return (
        <div>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                    <span>Количество мест: </span>
                    <InputNumber min={1} value={maxPlace} onChange={(value) => {
                        setMaxPlace(value);
                    }} />
                    <Button loading={loading} style={{marginLeft: "5px"}} onClick={onClickButton}>Применить</Button>
                </div>
                <div style={{ padding: "0 0 25px 0", textAlign: "right" }}>
                    <CopyToClipboard text={text}
                        onCopy={() => message.success("Скопировано")}>
                        <Button loading={loading} >Скопировать</Button>
                    </CopyToClipboard>
                </div>
            </div>

            {loading && <div style={{ textAlign: "center" }}><Spin size="large" /></div>}
            {!loading && <pre>
                {text}
            </pre>}
        </div>
    );
}
